import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { CurrencyCode } from "models/enums/currency";
import { RutRotSummaryProps } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const QuotationRutRotSummary: React.FC<RutRotSummaryProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { values } = props;
  const houseWorkType = values.rutRot?.houseWorkType;

  const houseWorkTypeText = houseWorkType ? invoiceService.getRutOrRotText(Number(houseWorkType)) : "";

  const selectedRows =
    values.products?.filter((prod) =>
      // eslint-disable-next-line eqeqeq --- ids can be string|number
      values.rutRot?.rutRotArticles?.some((rutRotItem) => rutRotItem.id == prod.uniqueId)
    ) ?? [];

  const totalLaborCost = selectedRows
    .map((prod) => invoiceService.calculateAmount(prod.price ?? 0, prod.quantity))
    .reduce((a, b) => +a + +b, 0);

  return (
    <Grid container spacing={2} direction={"column"}>
      <Grid container item spacing={3} className={cssExports.formLabel}>
        <Grid item container xs={8}>
          {houseWorkType &&
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RutRotSummaryService, "", {
              houseWorkType: houseWorkTypeText,
            })}
        </Grid>
        <Grid item container xs={4} justifyContent={"flex-end"}>
          {houseWorkType &&
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RutRotSummaryCost, "", {
              houseWorkType: houseWorkTypeText,
            })}
        </Grid>
      </Grid>
      <Grid container item>
        {values.rutRot?.rutRotArticles?.map((item) => {
          // eslint-disable-next-line eqeqeq --- ids can be string|number
          const prod = values.products?.find((p) => p.uniqueId == item.id);
          return (
            <Grid key={item.id} container item spacing={3}>
              <Grid item xs={8} className={clsx(cssExports.formControlLabel)}>
                {item.name}
              </Grid>
              <Grid
                item
                container
                xs={4}
                justifyContent={"flex-end"}
                className={clsx(cssExports.formValue, cssExports.whiteSpaceNoWrap)}
              >
                {LocalizationHelperInstance.getFormattedCurrency(
                  invoiceService.calculateAmount(prod?.price ?? 0, prod?.quantity),
                  CurrencyCode.SEK,
                  2
                )}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      <Grid container item spacing={3}>
        <Grid item xs={8} className={clsx(cssExports.formControlLabel)}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.TotalLaborCost)}
        </Grid>
        <Grid item container xs={4} justifyContent={"flex-end"} className={cssExports.formValue}>
          {LocalizationHelperInstance.getFormattedCurrency(totalLaborCost, CurrencyCode.SEK, 2)}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default QuotationRutRotSummary;
